import React, { RefObject } from 'react'
import { twMerge } from 'tailwind-merge'
import { Color } from '../../utils/constants'

interface StepIndicatorProps {
  lastScrolledIndex: number
  index: number
  color: Color
  slug: string
  scrollRef: RefObject<HTMLDivElement>
}

const StepIndicator = ({
    lastScrolledIndex,
    index,
    color,
    slug,
    scrollRef,
}: StepIndicatorProps) => {
    const onClick = () => {
        const leftScroll = document.getElementById(`segment-${slug}`)?.getBoundingClientRect().left ?? 0
        const leftPadding =
      parseInt(scrollRef.current?.style.paddingLeft ?? '0') - (scrollRef.current?.scrollLeft ?? 0)
    scrollRef.current?.scroll(leftScroll - leftPadding, 0)
    }
    return (
        <button className='relative flex justify-center z-10' onClick={onClick}>
            <h6
                className={twMerge(
                    'absolute w-max -top-full -mt-4 transition delay-500 opacity-40 segment-link',
                    lastScrolledIndex >= index && 'opacity-100',
                )}
            >{`Case ${('0' + (index + 1)).slice(-2)}`}</h6>
            <div
                className={twMerge(
                    'w-2 h-2 border-2 border-black rounded-full flex-shrink-0 transition delay-500',
                )}
                style={{ backgroundColor: lastScrolledIndex >= index ? Color.BLACK : color }}
            />
        </button>
    )
}

export default StepIndicator
